module.exports = __webpack_public_path__ + "static/atb-colour-logo-31ef3a012c0b6644da8040aa008243f0.jpg";